"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderXML = void 0;
const loadEL_1 = __importDefault(require("../node/el/loadEL"));
const formatXml_1 = __importDefault(require("../util/formatXml"));
const renderXML = (elOrJsonEL, withControlEl = false, format = false) => {
    const el = (0, loadEL_1.default)(elOrJsonEL);
    let body = el.outerXML(withControlEl);
    if (format)
        body = (0, formatXml_1.default)(body);
    const xml = `\
<?xml version="1.0" encoding="utf-8"?>
${body}
`;
    return xml;
};
exports.renderXML = renderXML;
exports.default = exports.renderXML;
//# sourceMappingURL=xml.js.map